import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const LoginPhoneNumber = () => {
    return (
        <div id="phone-login-page">
            <div className="title-phone-number-login xmb-5 xpx-2">
                <span>ورود / ثبت‌نام سایمان دیجیتال</span>
            </div>
            <div className="description-login-page xmb-6 xpx-2">
                <span>شماره موبایل یا پست الکترونیک خود را وارد کنید</span>
            </div>
            <form id="submit-form-number-login-page">
                <div className="input-log-in position-relative xmb-6 xmb-md-8">
                    <input
                        type="number" maxLength="11" placeholder="شماره موبایل شما" autoFocus={true}
                        className="form-control input-normal" id="input-phone-login-page"/>
                    <div className="text-error-phone xmt-2 xmr-6" id="text-error-phone">
                        شماره وارد شده نا معتبر می باشد
                    </div>
                    <div className="phone-icon position-absolute">
                        <IconName name="phone" className="icon"/>
                    </div>
                    <div className="error-icon position-absolute" id="error-icon-phone-number">
                        <IconName name="info" className="icon"/>
                    </div>
                </div>
                <div className="button-log-in xmb-6 xmb-md-8">
                    <button type="submit" id="button-phone-login-page">ورود به سایمان
                        دیجیتال</button>
                </div>
            </form>
            <div className="policy xpt-4 xpx-2">
                <p>با کلیک روی دکمه ورود به سایمان دیجیتال <a href="#">قوانین استفاده و حریم خصوصی</a> را
                    می‌پذیرم.</p>
            </div>
        </div>
    );
};

export default LoginPhoneNumber;
